[
  {
    "code": "LB-AK",
    "name": "Aakkâr"
  },
  {
    "code": "LB-JA",
    "name": "Al Janub"
  },
  {
    "code": "LB-AS",
    "name": "Ash Shimal"
  },
  {
    "code": "LB-BH",
    "name": "Baalbek-Hermel"
  },
  {
    "code": "LB-BA",
    "name": "Bayrut"
  },
  {
    "code": "LB-BI",
    "name": "Béqaa"
  },
  {
    "code": "LB-JL",
    "name": "Mont-Liban"
  },
  {
    "code": "LB-NA",
    "name": "Nabatîyé"
  }
]